/**
 * Check if a user has provided permission
 * @param user
 * @param name
 * @returns {boolean}
 */
export const hasPermission = (user, name) => {
  return !!user.permissions[name];
};
